// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ppp[data-v-484ef237]{margin-bottom:8px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
